import getConfig from 'next/config'
import { getCountryDetails } from './helpers'
const { publicRuntimeConfig, serverRuntimeConfig } = getConfig()

// Wrapper methods for calling various KP5 service APIs
// Response should return json result or error

export const getRegistrationDefaultValues = async (cookie, service) => {
  try {
    let apiUrl = `${serverRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/register/defaultValues`
    if (service && service.length > 0) {
      const defaultValueGetParams = new URLSearchParams()
      defaultValueGetParams.set('productParam', service)
      apiUrl = `${apiUrl}?${defaultValueGetParams.toString()}`
    }
    console.log('GET defaultValues url:', apiUrl)
    const response = await fetch(apiUrl, {
      method: 'GET',
      credentials: 'include',
      headers: cookie && { cookie }
    })

    const responseJSON = await response.json()
    responseJSON.data.supportedCountries = responseJSON.data.supportedCountries.map((country) => {
      return getCountryDetails(country.iso2) || country
    })
    responseJSON.data.defaultValues.street1 = responseJSON.data.defaultValues.address.street1
    responseJSON.data.defaultValues.street2 = responseJSON.data.defaultValues.address.street2
    responseJSON.data.defaultValues.city = responseJSON.data.defaultValues.address.city
    responseJSON.data.defaultValues.province = responseJSON.data.defaultValues.address.province
    responseJSON.data.defaultValues.zipCode = responseJSON.data.defaultValues.address.zipCode
    responseJSON.data.defaultValues.country = responseJSON.data.defaultValues.address.country
    responseJSON.data.defaultValues.website = responseJSON.data.defaultValues.address.website

    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const submitRegistration = async (
  data,
  productParam,
  agreements,
  userRegistrationLang = 'en',
  registrationReason = ''
) => {
  let finalData = {}
  if (data) {
    finalData = {
      firstName: data.firstName,
      lastName: data.lastName,
      tenantName: data.tenantName,
      officeNumber: data.officeNumber,
      companySize: data.companySize,
      industry: data.industry,
      receiveEmails: data.receiveEmails,
      legalAgreements: data.legalAgreements,
      address: {
        street1: data.street1,
        street2: data.street2,
        city: data.city,
        province: data.province,
        zipCode: data.zipCode,
        country: data.country,
        website: data.website
      }
    }
    if (productParam === 'msp') {
      finalData.mspInfo = {
        supportEmail: data.supportEmail || data.mspInfo.supportEmail,
        supportPhone: data.supportPhone || data.mspInfo.supportPhone,
        customerIndustries: data.industry
      }
    }
  }
  if (agreements) {
    finalData = {
      legalAgreements: agreements
    }
  }

  finalData.locale = userRegistrationLang
  finalData.registrationReason = registrationReason

  console.log('submitRegistration finalData:', finalData)
  console.log('submitRegistration productParam:', productParam)
  console.log('submitRegistration registration Reason', registrationReason)
  console.log('submitRegistration userRegistration Language:', userRegistrationLang)

  try {
    let apiUrl = `${publicRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/register/finish`
    if (productParam?.length > 0) {
      const registerGetParams = new URLSearchParams()
      registerGetParams.set('productParam', productParam)
      apiUrl = `${apiUrl}?${registerGetParams.toString()}`
    }
    console.log('POST /api/v1/register/finish url:', apiUrl)
    const response = await fetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify(finalData),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    const responseJSON = await response.json()
    if (!response.ok) {
      return {
        message: `Registration Failed`,
        requestID: response.headers.get('x-request-id'),
        statusCode: responseJSON.statusCode
      }
    }
    console.log('POST /api/v1/register/finish responseJSON:', responseJSON)
    responseJSON.requestID = response.headers.get('x-request-id')
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const registerWithEmail = async (email, locale) => {
  try {
    let apiUrl = `${publicRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/register/start`
    const requestBody = { email }
    const options = {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const response = await fetch(apiUrl, options)
    // if (!response.ok) {
    //   throw `fetch registerWithEmail failed: ${response.status} ${response.statusText}`
    // }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const registerWithEmailServer = async (email) => {
  try {
    let apiUrl = `${serverRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/register/start`
    const requestBody = { email }
    const options = {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const response = await fetch(apiUrl, options)
    if (!response.ok) {
      throw `fetch registerWithEmail failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getRegisterLegalByCountry = async (country, productParam) => {
  try {
    let apiUrl = `${publicRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/register/legalDocsForCountry/${country}`
    if (productParam) {
      const requestGetParams = new URLSearchParams()
      requestGetParams.set('productParam', productParam)
      apiUrl = `${apiUrl}?${requestGetParams.toString()}`
    }
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!response.ok) {
      throw `getRegisterLegalByCountry failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const submitAccountRequestAccess = async (
  productParam,
  service = 'finish',
  legalAgreements,
  incomingCustomerId
) => {
  try {
    const requestBody = {}
    if (legalAgreements) {
      requestBody.legalAgreements = legalAgreements
    }
    if (incomingCustomerId) {
      requestBody.incomingCustomerId = incomingCustomerId
    }
    const requestGetParams = new URLSearchParams()
    if (productParam) {
      requestGetParams.set('productParam', productParam)
    }
    const apiUrl = `${
      publicRuntimeConfig.tenantsUsersApiBaseUrl
    }/api/v1/requestAccess/${service}?${requestGetParams.toString()}`
    console.log(`POST submitAccountRequestAccess with productParam "${productParam}" url:`, apiUrl)
    const response = await fetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!response.ok) {
      return { requestID: response.headers.get('x-request-id') }
    }
    const responseJSON = await response.json()
    responseJSON.requestID = response.headers.get('x-request-id')
    console.log(`POST /api/v1/requestAccess/finish responseJSON:`, responseJSON)
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getRequestAccessLegalByCountry = async (productParam) => {
  try {
    let apiUrl = `${publicRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/requestAccess/legalDocs`
    if (productParam) {
      const requestGetParams = new URLSearchParams()
      requestGetParams.set('productParam', productParam)
      apiUrl = `${apiUrl}?${requestGetParams.toString()}`
    }
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!response.ok) {
      throw `getRequestAccessLegalByCountry failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getRequestAccessLegalByCountryServer = async (cookie, productParam) => {
  try {
    let apiUrl = `${serverRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/requestAccess/legalDocs`
    if (productParam) {
      const requestGetParams = new URLSearchParams()
      if (Array.isArray(productParam) && productParam.length) {
        for (const p of productParam) {
          requestGetParams.append('productParams', p)
        }
      } else {
        requestGetParams.set('productParam', productParam)
      }
      apiUrl = `${apiUrl}?${requestGetParams.toString()}`
    }

    const headers = {
      'Content-Type': 'application/json'
    }
    if (cookie) {
      headers['Cookie'] = cookie
    }
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers
    })
    if (!response.ok) {
      throw `getRequestAccessLegalByCountry failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getCurrentUserInvitations = async (cookie) => {
  try {
    let apiUrl = `${serverRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/account/current/invitation`
    const headers = {
      'Content-Type': 'application/json'
    }
    if (cookie) {
      headers['Cookie'] = cookie
    }
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers
    })
    if (!response.ok) {
      throw `getCurrentUserInvitations failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}
